module.exports = __webpack_public_path__ + "static/media/ban-solid.706d20f2.svg";